import { takeLatest, takeEvery } from 'redux-saga';
import { apply, call, put } from 'redux-saga/effects';
import { delay } from '../../../common/utils.jsx';
import { api } from '../../../common/api/api.js';
import { response, fail, AJAX_AUTOCOMPLETE_FETCH, CONCEPT_SERVICE, QUESTIONNAIRE_SERVICE, AJAX_AUTOCOMPLETE_INIT_DATA } from './reducer.jsx';
import { MANUAL_CANCEL } from '../../constants.jsx';

export function* getAutocompleteData(action) {
    const DEBOUNCE_DELAY = 1000;
    const { service: serviceName, payload, name, type } = action;
    const args = [];
    let service, method;
    switch (serviceName) {
        case CONCEPT_SERVICE:
            service = api.service(CONCEPT_SERVICE);
            if (payload.string && '' !== payload.string) { service.search(payload.string); }
            service.filter(payload.conceptType)
                .limit(20)
                .disableLast()
                .disableCustom();
            method = service.get;
            break;
        case QUESTIONNAIRE_SERVICE:
            service = api.service(QUESTIONNAIRE_SERVICE);
            method = service.getConcepts;
            args.push({ data: { string: payload.string } });
            break;
        default:
            throw new TypeError(`No such service: ${serviceName}`);
    }

    try {
        // TODO: remove try/catch and uses promises
        if (AJAX_AUTOCOMPLETE_FETCH === type) {
            yield call(delay, DEBOUNCE_DELAY);
        }
        const responseData = yield apply(service, method, args);
        const responseActionObject = response(name, serviceName, payload, responseData);
        yield put(responseActionObject);
    } catch (error) {
        if (error && error.type && MANUAL_CANCEL === error.type) {
            // Manual cancel is not an error, ignore it
            return;
        }
        const errorActionObject = fail(name, serviceName, payload, error);
        yield  put(errorActionObject);
        console.warn('Request failed:');
        console.log(error);
    }
}


export default function* autocompleteSaga() {
    yield [
        takeEvery(AJAX_AUTOCOMPLETE_INIT_DATA, getAutocompleteData),
        takeLatest(AJAX_AUTOCOMPLETE_FETCH, getAutocompleteData)
    ];
}
